import styled from "styled-components";

export const Container = styled.main`
  /* background: url(/images/bg_sample.jpg) no-repeat center center; */
  .inner{
    padding-top: 100px;
    padding-bottom: 100px;
    
    .wrap{
      /* width: 480px;
      padding: 90px 100px;
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(10px);
      box-shadow: 0 25px 25px rgba(0, 0, 0, 0.1); */
    }

    .btn_certification, .btn_signup{
      width: 100%;
      height: 46px;
      border-radius: 6px;
    }

    .btn_certification{
      margin-bottom: 36px;
    }

    .name, .tel{
      height: 36px;
      line-height: 36px;
      margin-bottom: 24px;
    }

    ul{
      margin: 48px 0;
      li + li{
        margin-top: 18px;
      }
    }
  }


  @media screen and (min-width: 501px) {
    section{
      width: 360px;
      margin: 0 auto;
    }
  }

  @media (max-width: 500px) {
    section{
      width: 100%;
    }
  }
`